import { inverterInformation } from "../../DataFiles/inverterInformation";
import {
  updateQuantityInfo,
  updateRoofInverterAnalysis,
} from "../../../Features/quantityInfo";
import { updateInverterAnalysis } from "../../../Features/roofInfo";
import { shadingLosses } from "../Functions/generationCalculate";
import { panelInformation } from "../../DataFiles/panelInformation";

export const handleElectricalConfiguration = (value, dispatch) => {
  if (value === "All Roof") {
    dispatch(
      updateQuantityInfo({ electricalConfiguration: value, allRoof: true })
    );
  } else {
    dispatch(
      updateQuantityInfo({ electricalConfiguration: value, allRoof: false })
    );
  }
};

export const handlePhase = (
  e,
  setInverterList,
  dispatch,
  quantityInfo,
  inverterDetail
) => {
  const value = e.target.value;
  let check = quantityInfo.allRoof;
  let list = inverterInformation.filter(
    (item) =>
      item.phase === value && item.systemType === inverterDetail.systemType
  );
  if (check) {
    dispatch(
      updateInverterAnalysis({
        systemType: inverterDetail.systemType,
        inverterPhase: value,
        inverterManufacturer: "Select",
        inverterType: "Select",
        powerSensor: "No Power Sensor",
        communicationDevice: "No Communication Device",
        noOfInverter: 0,
        DCACRatio: 1.2,
        feedMeter: false,
        noOfStringMPPT: 0,
        actualStringMPPT: 0,
        actualString: 0,
        totalStringMPPT: 0,
        lastStringMPPT: 0,
        error: "",
        errorShow: false,
        oneLineMethod: inverterDetail.oneLineMethod,
      })
    );
  } else {
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          systemType: inverterDetail.systemType,
          inverterPhase: value,
          inverterManufacturer: "Select",
          inverterType: "Select",
          powerSensor: "No Power Sensor",
          communicationDevice: "No Communication Device",
          noOfInverter: 0,
          DCACRatio: 1.2,
          feedMeter: false,
          noOfStringMPPT: 0,
          actualStringMPPT: 0,
          actualString: 0,
          totalStringMPPT: 0,
          lastStringMPPT: 0,
          error: "",
          errorShow: false,
          oneLineMethod: inverterDetail.oneLineMethod,
        },
      })
    );
  }
  setInverterList(list);
};

export const handleSystemType = (
  e,
  setInverterList,
  dispatch,
  quantityInfo,
  inverterDetail
) => {
  const value = e.target.value;
  let check = quantityInfo.allRoof;
  let list = inverterInformation.filter(
    (item) =>
      item.phase === inverterDetail.inverterPhase && item.systemType === value
  );

  if (check) {
    dispatch(
      updateInverterAnalysis({
        systemType: value,
        inverterPhase: inverterDetail.inverterPhase,
        inverterManufacturer: "Select",
        inverterType: "Select",
        powerSensor: "No Power Sensor",
        communicationDevice: "No Communication Device",
        noOfInverter: 0,
        DCACRatio: 1.2,
        feedMeter: false,
        noOfStringMPPT: 0,
        actualStringMPPT: 0,
        actualString: 0,
        totalStringMPPT: 0,
        lastStringMPPT: 0,
        error: "",
        errorShow: false,
        oneLineMethod: inverterDetail.oneLineMethod,
      })
    );
  } else {
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          systemType: value,
          inverterPhase: inverterDetail.inverterPhase,
          inverterManufacturer: "Select",
          inverterType: "Select",
          powerSensor: "No Power Sensor",
          communicationDevice: "No Communication Device",
          noOfInverter: 0,
          DCACRatio: 1.2,
          feedMeter: false,
          noOfStringMPPT: 0,
          actualStringMPPT: 0,
          actualString: 0,
          totalStringMPPT: 0,
          lastStringMPPT: 0,
          error: "",
          errorShow: false,
          oneLineMethod: inverterDetail.oneLineMethod,
        },
      })
    );
  }
  setInverterList(list);
};

export const handleOneLineMethod = (
  e,
  dispatch,
  quantityInfo,
  roofInfo,
  inverterDetail,
  roofDetail,
  setCommunicationDevice
) => {
  const value = e.target.value;
  let list = inverterInformation.find(
    (item) =>
      item.phase === inverterDetail.inverterPhase &&
      item.systemType === inverterDetail.systemType &&
      item.brand === inverterDetail.inverterManufacturer
  );
  let type = list.inverterType.find(
    (item) => item.name === inverterDetail.inverterType
  );
  if (type.value > 300 && value === "MPPT") {
    alert(`${type.name} for this inverter MPPT type is not available`);
    return false;
  }

  let check = quantityInfo.allRoof;

  if (check) {
    dispatch(
      updateInverterAnalysis({
        oneLineMethod: value,
      })
    );
  } else {
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          oneLineMethod: value,
        },
      })
    );
  }
  const changes = {
    ...inverterDetail,
    oneLineMethod: value,
  };
  inverterDetail = changes;

  if (inverterDetail.inverterType !== "Select") {
    handleInverterType({
      type,
      dispatch,
      roofInfo,
      roofDetail,
      inverterDetail,
      quantityInfo,
      setCommunicationDevice,
    });
  }
};

export const handleInverterList = ({
  inverter,
  dispatch,
  setInverterTypeList,
  roofDetail,
  inverterDetail,
  quantityInfo,
  setPowerSensorList,
  setCommunicationDevice,
}) => {
  let check = quantityInfo.allRoof;
  let roofData = quantityInfo?.roofData || [];
  let capacity = 0;

  if (check) {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      capacity += Number(element.totalKilowatt);
    }
  } else {
    capacity = roofDetail.totalKilowatt;
  }

  const array = inverter.inverterType;
  if (inverter.brand === "HUAWEI") {
    HUAWEI(setPowerSensorList, capacity, inverter.powerSensor);
  } else {
    setPowerSensorList(inverter.powerSensor);
  }
  setCommunicationDevice(inverter.communicationDevice);

  setInverterTypeList(array);

  if (check) {
    if (inverter.brand !== inverterDetail.inverterManufacturer) {
      dispatch(
        updateInverterAnalysis({
          inverterType: "Select",
          powerSensor: "No Power Sensor",
          communicationDevice: "No Communication Device",
        })
      );
    }
    dispatch(updateInverterAnalysis({ inverterManufacturer: inverter.brand }));
  } else {
    if (inverter.brand !== inverterDetail.inverterManufacturer) {
      dispatch(
        updateRoofInverterAnalysis({
          index: quantityInfo.roofNo,
          fields: {
            inverterType: "Select",
            powerSensor: "No Power Sensor",
            communicationDevice: "No Communication Device",
          },
        })
      );
    }
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          inverterManufacturer: inverter.brand,
        },
      })
    );
  }
};

export const handleInverterType = ({
  type,
  dispatch,
  roofInfo,
  roofDetail,
  inverterDetail,
  quantityInfo,
  setCommunicationDevice,
}) => {
  let check = quantityInfo.allRoof;
  let roofData = quantityInfo?.roofData || [];
  let noOfPanel = 0;
  let capacity = 0;
  if (check) {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      noOfPanel += element.pvModule;
      capacity += Number(element.totalKilowatt);
    }
    dispatch(updateInverterAnalysis({ errorShow: false }));
  } else {
    noOfPanel = roofDetail.pvModule;
    capacity = roofDetail.totalKilowatt;
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: false,
        },
      })
    );
  }

  if (type?.value > 300 && capacity < 300) {
    alert(`${type.name} is available for more than 300kW system size`);
    return false;
  }

  const DCACRatio = inverterDetail.DCACRatio;
  const efficiency = type.efficiency / 100;
  shadingLosses(quantityInfo, dispatch, efficiency);

  const inverterSizing = Number((type.value * DCACRatio).toFixed(2));

  const totalInverter = Number((capacity / inverterSizing).toFixed(2));

  let noOfInverter = totalInverter < 1 ? 1 : totalInverter;
  let totalPanel = noOfPanel;

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  const mpptAvailable = noOfInverter * type.noOfMPPT;

  let noOfPanelPerMPPT = Number((totalPanel / mpptAvailable).toFixed());
  let noOfPanelPerString = Number(
    ((type.value * DCACRatio * 1000) / panel.pMax / type.noOfStrings).toFixed()
  );

  let lastStringMPPT;
  let error = ``;

  if (check) {
    if (inverterDetail.oneLineMethod === "MPPT") {
      if (totalPanel < 5) {
        alert("Software can't configure below 5 Module");
        return false;
      }
      mpptConfigurationAllRoof({
        lastStringMPPT,
        noOfPanelPerMPPT,
        type,
        error,
        noOfInverter,
        dispatch,
        totalPanel,
        quantityInfo,
      });
    } else {
      stringConfigurationAllRoof({
        lastStringMPPT,
        noOfPanelPerString,
        type,
        error,
        noOfInverter,
        dispatch,
        totalPanel,
        quantityInfo,
      });
    }
  } else {
    if (inverterDetail.oneLineMethod === "MPPT") {
      if (totalPanel < 5) {
        alert("Software can't configure below 5 Module");
        return false;
      }
      mpptConfiguration({
        lastStringMPPT,
        noOfPanelPerMPPT,
        type,
        error,
        noOfInverter,
        dispatch,
        totalPanel,
        quantityInfo,
      });
    } else {
      stringConfiguration({
        lastStringMPPT,
        noOfPanelPerString,
        type,
        error,
        noOfInverter,
        dispatch,
        totalPanel,
        quantityInfo,
      });
    }
  }

  if (window.location.pathname === "/electrical") {
    if (inverterDetail.inverterManufacturer === "HUAWEI") {
      huaweiCommunication(setCommunicationDevice, type.value);
    }
  }
};

export const handlePowerSensor = (value, dispatch, quantityInfo) => {
  let check = quantityInfo.allRoof;

  if (check) {
    if (value !== "Select") {
      dispatch(
        updateInverterAnalysis({
          feedMeter: true,
          powerSensor: value,
        })
      );
    } else {
      dispatch(
        updateInverterAnalysis({
          feedMeter: false,
          powerSensor: value,
        })
      );
    }
  } else {
    if (value !== "Select") {
      dispatch(
        updateRoofInverterAnalysis({
          index: quantityInfo.roofNo,
          fields: {
            feedMeter: true,
            powerSensor: value,
          },
        })
      );
    } else {
      dispatch(
        updateRoofInverterAnalysis({
          index: quantityInfo.roofNo,
          fields: {
            feedMeter: false,
            powerSensor: value,
          },
        })
      );
    }
  }
};

export const handleCommunicationDevice = (value, dispatch, quantityInfo) => {
  let check = quantityInfo.allRoof;
  if (check) {
    dispatch(updateInverterAnalysis({ communicationDevice: value }));
  } else {
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          communicationDevice: value,
        },
      })
    );
  }
};

export const handleApply = ({
  dispatch,
  roofInfo,
  roofDetail,
  inverterDetail,
  quantityInfo,
  setCommunicationDevice,
}) => {
  let inverter = inverterInformation.find(
    (item) =>
      item.brand === inverterDetail.inverterManufacturer &&
      item.phase === inverterDetail.inverterPhase &&
      item.systemType === inverterDetail.systemType
  );
  let type = inverter.inverterType.find(
    (item) => item.name === inverterDetail.inverterType
  );

  handleInverterType({
    type,
    dispatch,
    roofInfo,
    roofDetail,
    inverterDetail,
    quantityInfo,
    setCommunicationDevice,
  });
};

const stringConfiguration = ({
  lastStringMPPT,
  noOfPanelPerString,
  type,
  error,
  noOfInverter,
  dispatch,
  totalPanel,
  quantityInfo,
}) => {
  let totalStringMPPT = type.noOfStrings;
  if (type.value >= 330 && noOfPanelPerString > 30) {
    noOfPanelPerString = 30;
  } else if (type.value < 150 && noOfPanelPerString > 18) {
    noOfPanelPerString = 18;
  } else if (noOfPanelPerString < 5 && totalStringMPPT > 3 && type.value >= 5) {
    // noOfPanelPerString = 5;
    noOfPanelPerString = type.value >= 330 ? 12 : 5;
  }
  noOfInverter = 0;
  const check = 4;

  dispatch(
    updateRoofInverterAnalysis({
      index: quantityInfo.roofNo,
      fields: {
        actualString: type.noOfStrings,
        actualStringMPPT: noOfPanelPerString,
      },
    })
  );

  for (let i = 0; i < totalPanel; ) {
    noOfInverter += 1;
    let use = i + totalStringMPPT * noOfPanelPerString;
    let leftPanel = totalPanel - i;
    if (use > totalPanel) {
      if (type.value > 300) {
        if (noOfPanelPerString < 12) {
          noOfPanelPerString = 12;
        }
        totalStringMPPT = 0;
        for (let i = 0; i < leftPanel; ) {
          totalStringMPPT += 2;
          i += noOfPanelPerString * 2;
          if (
            leftPanel - i < 24 &&
            noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2)) <= 30
          ) {
            lastStringMPPT =
              noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2));
            i += leftPanel - i;
          }
        }
        i += leftPanel;
      } else {
        if (noOfPanelPerString < 5) {
          noOfPanelPerString = 5;
        }
        totalStringMPPT = 0;
        for (let i = 0; i < leftPanel; ) {
          totalStringMPPT += 2;
          i += noOfPanelPerString * 2;
          if (
            leftPanel - i < 10 &&
            noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2)) <= 18
          ) {
            lastStringMPPT =
              noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2));
            i += leftPanel - i;
          }
        }
        i += leftPanel;
      }
    } else {
      i += totalStringMPPT * noOfPanelPerString;

      let leftPanel = totalPanel - i;
      if (
        leftPanel <= check &&
        noOfPanelPerString + Number(Math.floor(leftPanel / 2)) <= 18
      ) {
        lastStringMPPT = noOfPanelPerString + Number(Math.floor(leftPanel / 2));
        i += leftPanel;
      }
    }
  }

  const usePanel =
    (noOfInverter - 1) * noOfPanelPerString * type.noOfStrings +
    (totalStringMPPT - 2) * noOfPanelPerString +
    2 * lastStringMPPT;
  if (
    type.value > 300 &&
    (lastStringMPPT > 30 ||
      noOfPanelPerString > 30 ||
      noOfPanelPerString < 12 ||
      lastStringMPPT < 12)
  ) {
    error +=
      "String sized is mismatch change DC/AC ratio else change inverter size.";
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: true,
        },
      })
    );
  } else if (
    type.value < 150 &&
    (lastStringMPPT > 18 ||
      noOfPanelPerString > 18 ||
      noOfPanelPerString < 5 ||
      lastStringMPPT < 5)
  ) {
    error +=
      "String sized is mismatch change DC/AC ratio else change inverter size or else shift to MPPT configuration. ";
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: true,
        },
      })
    );
  } else if (totalPanel > usePanel) {
    error +=
      "Due to odd string sizing software reduce one panel to make it optimal. ";
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: true,
        },
      })
    );
  }

  if (totalStringMPPT < type.noOfStrings) {
    error += `For geting optimal result software reduced the Strings/MPPT from ${type.noOfStrings} to ${totalStringMPPT}.`;
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: true,
        },
      })
    );
  }

  dispatch(
    updateRoofInverterAnalysis({
      index: quantityInfo.roofNo,
      fields: {
        noOfStringMPPT: noOfPanelPerString,
        totalStringMPPT: totalStringMPPT,
        noOfInverter: noOfInverter,
        lastStringMPPT: lastStringMPPT,
        inverterType: type.name,
        error: error,
      },
    })
  );
};

const mpptConfiguration = ({
  lastStringMPPT,
  noOfPanelPerMPPT,
  type,
  error,
  noOfInverter,
  dispatch,
  totalPanel,
  quantityInfo,
}) => {
  let totalStringMPPT = type.noOfMPPT;

  if (noOfPanelPerMPPT > 18) {
    noOfPanelPerMPPT = 18;
  } else if (noOfPanelPerMPPT < 5) {
    totalStringMPPT = Number(
      Math.floor((noOfPanelPerMPPT * type.noOfMPPT) / 5)
    );
    noOfPanelPerMPPT = 5;
  }
  noOfInverter = 0;
  const check = 2;
  dispatch(
    updateRoofInverterAnalysis({
      index: quantityInfo.roofNo,
      fields: {
        actualString: totalStringMPPT,
        actualStringMPPT: noOfPanelPerMPPT,
        error: false,
      },
    })
  );

  for (let i = 0; i < totalPanel; ) {
    noOfInverter += 1;
    let use = i + totalStringMPPT * noOfPanelPerMPPT;
    let leftPanel = totalPanel - i;
    if (use > totalPanel) {
      totalStringMPPT = 0;
      for (let i = 0; i < leftPanel; ) {
        let check = i + noOfPanelPerMPPT;
        if (check >= leftPanel) {
          if (leftPanel - i > 4) {
            totalStringMPPT += 1;
            lastStringMPPT = leftPanel - i;
          } else {
            lastStringMPPT = noOfPanelPerMPPT;
            totalStringMPPT += 1;
          }
          i += leftPanel - i;
        } else {
          totalStringMPPT += 1;
          i += noOfPanelPerMPPT;
          if (leftPanel - i <= 2 && noOfPanelPerMPPT + (leftPanel - i) <= 18) {
            lastStringMPPT = noOfPanelPerMPPT + (leftPanel - i);
            i += leftPanel - i;
          }
        }
      }
      i += leftPanel;
    } else {
      i += totalStringMPPT * noOfPanelPerMPPT;
      let leftPanel = totalPanel - i;
      if (leftPanel <= check && noOfPanelPerMPPT + leftPanel <= 18) {
        lastStringMPPT = noOfPanelPerMPPT + leftPanel;
        i += leftPanel;
      }
    }
  }

  const usePanel =
    (noOfInverter - 1) * noOfPanelPerMPPT * type.noOfMPPT +
    (totalStringMPPT - 1) * noOfPanelPerMPPT +
    1 * lastStringMPPT;
  if (
    lastStringMPPT > 18 ||
    noOfPanelPerMPPT > 18 ||
    noOfPanelPerMPPT < 5 ||
    lastStringMPPT < 5
  ) {
    error +=
      "String sized is mismatch change DC/AC ratio else change inverter size else shift to string/MPPT.";
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: true,
        },
      })
    );
  } else if (totalPanel > usePanel) {
    error +=
      "Due to odd string sizing software reduce one panel to make it optimal. ";
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: true,
        },
      })
    );
  }

  if (totalStringMPPT < type.noOfMPPT) {
    error += `For geting optimal result software reduced the MPPT from ${type.noOfMPPT} to ${totalStringMPPT}.`;
    dispatch(
      updateRoofInverterAnalysis({
        index: quantityInfo.roofNo,
        fields: {
          errorShow: true,
        },
      })
    );
  }

  dispatch(
    updateRoofInverterAnalysis({
      index: quantityInfo.roofNo,
      fields: {
        noOfStringMPPT: noOfPanelPerMPPT,
        totalStringMPPT: totalStringMPPT,
        noOfInverter: noOfInverter,
        lastStringMPPT: lastStringMPPT,
        inverterType: type.name,
        error: error,
      },
    })
  );
};

const stringConfigurationAllRoof = ({
  lastStringMPPT,
  noOfPanelPerString,
  type,
  error,
  dispatch,
  totalPanel,
}) => {
  let totalStringMPPT = type.noOfStrings;
  if (type.value >= 330 && noOfPanelPerString > 30) {
    noOfPanelPerString = 30;
  } else if (type.value < 150 && noOfPanelPerString > 18) {
    noOfPanelPerString = 18;
  } else if (noOfPanelPerString < 5 && totalStringMPPT > 3 && type.value >= 5) {
    // noOfPanelPerString = 5;
    noOfPanelPerString = type.value >= 330 ? 12 : 5;
  }
  let noOfInverter = 0;
  const check = 4;

  dispatch(
    updateInverterAnalysis({
      actualString: type.noOfStrings,
      actualStringMPPT: noOfPanelPerString,
    })
  );

  for (let i = 0; i < totalPanel; ) {
    noOfInverter += 1;
    let use = i + totalStringMPPT * noOfPanelPerString;
    let leftPanel = totalPanel - i;
    if (use > totalPanel) {
      if (type.value > 300) {
        if (noOfPanelPerString < 12) {
          noOfPanelPerString = 12;
        }
        totalStringMPPT = 0;
        for (let i = 0; i < leftPanel; ) {
          totalStringMPPT += 2;
          i += noOfPanelPerString * 2;
          if (
            leftPanel - i < 24 &&
            noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2)) <= 30
          ) {
            lastStringMPPT =
              noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2));
            i += leftPanel - i;
          }
        }
        i += leftPanel;
      } else {
        if (noOfPanelPerString < 5) {
          noOfPanelPerString = 5;
        }
        totalStringMPPT = 0;
        for (let i = 0; i < leftPanel; ) {
          totalStringMPPT += 2;
          i += noOfPanelPerString * 2;
          if (
            leftPanel - i < 10 &&
            noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2)) <= 18
          ) {
            lastStringMPPT =
              noOfPanelPerString + Number(Math.floor((leftPanel - i) / 2));
            i += leftPanel - i;
          }
        }
        i += leftPanel;
      }
    } else {
      i += totalStringMPPT * noOfPanelPerString;

      let leftPanel = totalPanel - i;
      if (
        leftPanel <= check &&
        noOfPanelPerString + Number(Math.floor(leftPanel / 2)) <= 18
      ) {
        lastStringMPPT = noOfPanelPerString + Number(Math.floor(leftPanel / 2));
        i += leftPanel;
      }
    }
  }

  const usePanel =
    (noOfInverter - 1) * noOfPanelPerString * type.noOfStrings +
    (totalStringMPPT - 2) * noOfPanelPerString +
    2 * lastStringMPPT;
  if (
    type.value > 300 &&
    (lastStringMPPT > 30 ||
      noOfPanelPerString > 30 ||
      noOfPanelPerString < 12 ||
      lastStringMPPT < 12)
  ) {
    error +=
      "String sized is mismatch change DC/AC ratio else change inverter size. ";

    dispatch(updateInverterAnalysis({ errorShow: true }));
  } else if (
    type.value < 150 &&
    (lastStringMPPT > 18 ||
      noOfPanelPerString > 18 ||
      noOfPanelPerString < 5 ||
      lastStringMPPT < 5)
  ) {
    error +=
      "String sized is mismatch change DC/AC ratio else change inverter size or else shift to MPPT configuration. ";

    dispatch(updateInverterAnalysis({ errorShow: true }));
  } else if (totalPanel > usePanel) {
    error +=
      "Due to odd string sizing software reduce one panel to make it optimal. ";
    dispatch(updateInverterAnalysis({ errorShow: true }));
  }

  if (totalStringMPPT < type.noOfStrings) {
    error += `For geting optimal result software reduced the Strings/MPPT from ${type.noOfStrings} to ${totalStringMPPT}.`;
    dispatch(updateInverterAnalysis({ errorShow: true }));
  }
  dispatch(
    updateInverterAnalysis({
      noOfStringMPPT: noOfPanelPerString,
      totalStringMPPT: totalStringMPPT,
      noOfInverter: noOfInverter,
      lastStringMPPT: lastStringMPPT,
      inverterType: type.name,
      error: error,
    })
  );
};

const mpptConfigurationAllRoof = ({
  lastStringMPPT,
  noOfPanelPerMPPT,
  type,
  error,
  dispatch,
  totalPanel,
}) => {
  let totalStringMPPT = type.noOfMPPT;

  if (noOfPanelPerMPPT > 18) {
    noOfPanelPerMPPT = 18;
  } else if (noOfPanelPerMPPT < 5) {
    totalStringMPPT = Number(
      Math.floor((noOfPanelPerMPPT * type.noOfMPPT) / 5)
    );
    noOfPanelPerMPPT = 5;
  }
  let noOfInverter = 0;
  const check = 2;

  dispatch(
    updateInverterAnalysis({
      actualString: totalStringMPPT,
      actualStringMPPT: noOfPanelPerMPPT,
      error: false,
    })
  );

  for (let i = 0; i < totalPanel; ) {
    noOfInverter += 1;
    let use = i + totalStringMPPT * noOfPanelPerMPPT;
    let leftPanel = totalPanel - i;
    if (use > totalPanel) {
      totalStringMPPT = 0;
      for (let i = 0; i < leftPanel; ) {
        let check = i + noOfPanelPerMPPT;
        if (check >= leftPanel) {
          if (leftPanel - i > 4) {
            totalStringMPPT += 1;
            lastStringMPPT = leftPanel - i;
          } else {
            lastStringMPPT = noOfPanelPerMPPT;
            totalStringMPPT += 1;
          }
          i += leftPanel - i;
        } else {
          totalStringMPPT += 1;
          i += noOfPanelPerMPPT;
          if (leftPanel - i <= 2 && noOfPanelPerMPPT + (leftPanel - i) <= 18) {
            lastStringMPPT = noOfPanelPerMPPT + (leftPanel - i);
            i += leftPanel - i;
          }
        }
      }
      i += leftPanel;
    } else {
      i += totalStringMPPT * noOfPanelPerMPPT;
      let leftPanel = totalPanel - i;
      if (leftPanel <= check && noOfPanelPerMPPT + leftPanel <= 18) {
        lastStringMPPT = noOfPanelPerMPPT + leftPanel;
        i += leftPanel;
      }
    }
  }

  const usePanel =
    (noOfInverter - 1) * noOfPanelPerMPPT * type.noOfMPPT +
    (totalStringMPPT - 1) * noOfPanelPerMPPT +
    1 * lastStringMPPT;
  if (
    lastStringMPPT > 18 ||
    noOfPanelPerMPPT > 18 ||
    noOfPanelPerMPPT < 5 ||
    lastStringMPPT < 5
  ) {
    error +=
      "String sized is mismatch change DC/AC ratio else change inverter size else shift to string/MPPT.";
    dispatch(updateInverterAnalysis({ error: false }));
  } else if (totalPanel > usePanel) {
    error +=
      "Due to odd string sizing software reduce one panel to make it optimal. ";
    dispatch(updateInverterAnalysis({ error: false }));
  }

  if (totalStringMPPT < type.noOfMPPT) {
    error += `For geting optimal result software reduced the MPPT from ${type.noOfMPPT} to ${totalStringMPPT}.`;
    dispatch(updateInverterAnalysis({ error: false }));
  }

  dispatch(
    updateInverterAnalysis({
      noOfStringMPPT: noOfPanelPerMPPT,
      totalStringMPPT: totalStringMPPT,
      noOfInverter: noOfInverter,
      lastStringMPPT: lastStringMPPT,
      inverterType: type.name,
      error: error,
    })
  );
};

const HUAWEI = (setPowerSensorList, capacity, array) => {
  if (capacity >= 200) {
    setPowerSensorList(["No Power Sensor", "Chint DTSU666-HW/YDS60-80"]);
  } else {
    setPowerSensorList(array);
  }
};

const huaweiCommunication = (setCommunicationDevice, value) => {
  if (value <= 50) {
    setCommunicationDevice([
      "No Communication Device",
      "Smart Dongle-WLAN-FE",
      "Smart Dongle-4G",
      "SmartLogger3000A",
    ]);
  } else {
    setCommunicationDevice([
      "No Communication Device",
      "Smart Dongle-4G",
      "SmartLogger3000A",
    ]);
  }
};
